export default "__VITE_ASSET__DJLh16H5__"